import styled, { css } from 'styled-components';

// ** Utils
import { pxToRem } from 'utils/transform-px.utils';

// ** Styles
import { StyledVerticalLineItem } from 'styles/figure.styled';

export const PartnersListStyled = styled.section`
  padding: 0 0 ${pxToRem(125)} ${pxToRem(100)};
  position: relative;
  &:after {
    ${StyledVerticalLineItem};
    content: '';
    height: calc(100% - ${pxToRem(125)});
    left: ${pxToRem(40)};
    top: 0;
  }
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        padding: 0 ${pxToRem(60)} ${pxToRem(100)};
        &:after {
          display: none;
        }
      `
    )}
  ${(props) =>
    props.theme.media.down(
      'sm',
      css`
        padding: 0 ${pxToRem(20)} ${pxToRem(50)} ${pxToRem(54)};
        &:after {
          display: block;
          height: calc(100% - ${pxToRem(50)});
          left: ${pxToRem(20)};
        }
      `
    )}
`;
